import React, { Component } from 'react';
import AdminEconomicChart from '../AdminEconomicChart';
import './styles.scss';
class AdminSessionChart extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedKpi: 'revenues'
		};
	}
	render() {
		const { data } = this.props;
		const { selectedKpi } = this.state;
		const variablesNames = [
			{ id: 'revenues', label: 'Revenues' },
			{ id: 'operatingIncome', label: 'Operating Income (EBIT)' },
			{ id: 'cccSales', label: 'CCC/Sales' },
			{ id: 'cashFlowFromOperations', label: 'Cash Flow From Operations' },
			{ id: 'cash', label: 'Cash' },
			{ id: 'leverage', label: 'Leverage' },
			{ id: 'roe', label: 'ROE' },
			{ id: 'roa', label: 'ROA' }
		];
		return (
			<div className="AdminSessionChart">
				<div className="admin-session-chart">
					<AdminEconomicChart data={data} selectedKpi={selectedKpi} />
					<div className="admin-session-chart--legend">
						{variablesNames.map((variableName, i) => (
							<div
								key={i}
								className={`admin-session-chart--legend-item ${
									variableName.id === selectedKpi ? 'active' : ''
								}`}
								onClick={() => this.setState({ selectedKpi: variableName.id })}
							>
								{variableName.label}
							</div>
						))}
					</div>
				</div>
			</div>
		);
	}
}

export default AdminSessionChart;
